export default {
  namespaced: true,
  state: {
    groupList: []
  },
  mutations: {
    setGroupList(state, list) {
      state.groupList = list;
    }
  }
};
